import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  CHCP_FEDERATION_DETAILS_FEATURE_KEY,
  chcpFederationReducer,
} from './+state/chcp-federation.reducer';
import { ChcpFederationEffects } from './+state/chcp-federation.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      CHCP_FEDERATION_DETAILS_FEATURE_KEY,
      chcpFederationReducer,
    ),
    EffectsModule.forFeature([ChcpFederationEffects]),
  ],
})
export class ChcpSharedFederationDataAccessModule {}
